import {
  HOW_TO_TEST_STS_SIDE,
  STS_SIDE_INFO,
  TUG_FRONT_INFO,
  TUG_SIDE_INFO,
} from "../routes/routerPath";
import { resolveCustomerType } from "./personTerminology";

// Provisional backend module ID agreed for the initial STS release.
export const STS_MODULE_ID = 10;

const MODULES = [
  {
    moduleId: STS_MODULE_ID,
    route: STS_SIDE_INFO,
    guideRoute: HOW_TO_TEST_STS_SIDE,
    orientation: "portrait",
    displayRank: 0,
    captureRank: 0,
  },
  { moduleId: 4, route: TUG_FRONT_INFO, displayRank: 1, captureRank: 1 },
  { moduleId: 1, route: TUG_SIDE_INFO, displayRank: 2, captureRank: 2 },
];

export const isStsEligible = (account) =>
  ["home_care", "senior_living"].includes(resolveCustomerType(account));

export const getMeasurementModule = (id) =>
  MODULES.find((module) => module.moduleId === Number(id));

// Until the module-list API includes STS, eligible accounts get a local card.
// Explicit server permission (including false) and last-tested data take priority.
export const getAvailableMeasurementModules = (modules, account) => {
  const eligible = isStsEligible(account);
  const available = new Map();
  (Array.isArray(modules) ? modules : []).forEach((module) => {
    const metadata = getMeasurementModule(module?.moduleId);
    if (!metadata || (metadata.moduleId === STS_MODULE_ID && !eligible)) return;
    if (!available.has(metadata.moduleId)) {
      available.set(metadata.moduleId, {
        ...module,
        moduleId: metadata.moduleId,
      });
    }
  });
  if (eligible && !available.has(STS_MODULE_ID)) {
    available.set(STS_MODULE_ID, {
      moduleId: STS_MODULE_ID,
      isOperationAllowed: true,
      isReportAvailable: false,
      lastTestTaken: null,
    });
  }
  return [...available.values()].sort(
    (a, b) =>
      getMeasurementModule(a.moduleId).displayRank -
      getMeasurementModule(b.moduleId).displayRank,
  );
};
